import Model from '@/core/models/Model';

export default class Restriction extends Model {
  resource() {
    return 'app/restrictions';
  }
}
